import image1 from '../../../../assets/images/work/ontario-mine-rescue/OMR_detailed_img_1.jpg';
import image2 from '../../../../assets/images/work/ontario-mine-rescue/OMR_detailed_img_2.jpg';
import image4 from '../../../../assets/images/work/ontario-mine-rescue/OMR_detailed_abovefooter.jpg';

import artwork from '../../../../assets/images/art_2.png';

const Data_OntarioMineRescue = {
    content: (
        <>
            {/* PROBLEM + CHALLENGES */}
            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <div className="text-content-inner">
                        <div className="container">
                            <div className="row">
                                {/* PROBLEM */}
                                <div className="col-lg-6">
                                    <h4 className="heading heading-small light-2">PROBLEM</h4>

                                    <div className="paragraph light-1">
                                        <p className="mb-5">
                                            In high-risk underground environments, mine rescue teams must be ready to respond to complex emergency
                                            scenarios, yet realistic training scenarios can be difficult, costly, and dangerous to recreate in the
                                            real-world.
                                        </p>
                                        <p>
                                            Originally developed as an interactive installation to build public awareness, the Ontario Mine Rescue
                                            Experience evolved into a simulation with clear training potential. Built in partnership with Dynamic
                                            Earth and Ontario Mine Rescue, the experience supports skill-building and refresher practice by placing
                                            users into realistic emergency decision-making scenarios.
                                        </p>
                                    </div>
                                    <br />
                                </div>

                                {/* CHALLENGES */}
                                <div className="col-lg-6 second-column">
                                    <h4 className="heading heading-small light-2">CHALLENGES</h4>

                                    <div className="paragraph light-1">
                                        <p>
                                            The key challenge was creating an experience that was both accessible to the public and credible for
                                            real-world training. The simulation needed to reflect authentic underground rescue conditions, align
                                            with official protocols, and incorporate the real strategies, equipment, and decision-making used by
                                            Ontario Mine Rescue teams.
                                        </p>
                                        <br />
                                        <p>Designing the Ontario Mine Rescue experience required balancing realism with safety. Scenarios needed to feel authentic
                                            without recreating dangerous conditions, while all learning content had to align with official mine rescue protocols.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* PROJECT CONTENT */}
            <div className="project-content">
                <div className="project-content-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="project-content-inner">
                                    {/* Catchy Title / Hook */}
                                    <h2 className="heading heading-large dark-1">
                                        Step Into the Rescue: immersive experience of underground emergencies without the underground risk.
                                    </h2>

                                    <div className="paragraph dark-1">
                                        <p>
                                            The Ontario Mine Rescue Experience places users in the role of a mine rescue agent, offering a hands-on
                                            look at what it takes to travel underground and respond during an emergency scenario. Designed as an
                                            installation for Dynamic Earth, the experience also serves as a powerful tool to build awareness and
                                            reinforce critical response knowledge.
                                        </p>
                                    </div>

                                    <div className="heading heading-medium dark-1">
                                        <p>Built on Real Protocols</p>
                                    </div>

                                    <div className="paragraph dark-1">
                                        <p>
                                            Users are presented with guidance based on official mine rescue protocols, including fire extinguisher
                                            classification and usage standards, and how to properly extinguish a fire using widely recognized safety
                                            practices such as P.A.S.S. The result is an experience that's engaging for visitors and grounded in the
                                            procedures that matter during real incidents.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="single-image-wrapper">
                        <div className="single-image">
                            <img src={image1} alt="Ontario Mine Rescue project screenshot 6" />
                        </div>
                        <div className="single-image">
                            <img src={image2} alt="Ontario Mine Rescue project screenshot 7" />
                        </div>
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="project-content-inner">
                                    <h2 className="heading heading-medium dark-1">Scenario Variety & Critical Thinking</h2>

                                    <div className="paragraph dark-1">
                                        <p>
                                            A major strength of the experience is the ability to support many different emergency situations and
                                            environmental conditions. This flexibility allows trainers to challenge learners to think critically,
                                            apply protocols under pressure, and make safer decisions without the constraints of building physical
                                            training environments.
                                        </p>
                                    </div>

                                    <div className="text-list medium dark-1">
                                        <ul>
                                            <li>Immersive "step into the role" learning experience</li>
                                            <li>Protocol-based guidance and safety standards</li>
                                            <li>Flexible emergency scenarios for repeatable learning</li>
                                            <li>Designed for installation-based engagement and training value</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="single-image">
                        <img src={image4} alt="Ontario Mine Rescue project screenshot 8" />
                    </div>
                </div>
            </div>

            {/* RESULTS */}
            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <div className="text-content-inner">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h4 className="heading heading-small light-2">RESULTS</h4>

                                    <div className="paragraph light-1">
                                        <p>
                                            The Ontario Mine Rescue Experience delivers a unique, interactive way to understand the challenges mine
                                            rescue teams face underground, helping raise awareness while reinforcing emergency response knowledge in
                                            a realistic, repeatable format.
                                        </p>
                                        <br />
                                        <p>
                                            By incorporating real equipment, strategies, and decision-making approaches through close collaboration
                                            with Ontario Mine Rescue, the experience supports meaningful learning and can be used to challenge
                                            trainees with varied scenarios that promote stronger emergency response decisions.
                                        </p>
                                    </div>
                                </div>

                <div className="col-lg-5 offset-lg-1 second-column">
                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">PLATFORM</h4>
                    <div className="heading heading-medium light-1">
                      <p>LBI / PC VR</p>
                    </div>
                  </div>

                                    <div className="content-wrapper">
                                        <h4 className="heading heading-small light-2">CLIENT</h4>
                                        <div className="paragraph light-1">
                                            <p>Dynamic Earth / Ontario Mine Rescue</p>
                                        </div>
                                    </div>

                                    <div className="content-wrapper">
                                        <h4 className="heading heading-small light-2">LOCATION</h4>
                                        <div className="paragraph light-1">
                                            <p>Sudbury, ON</p>
                                        </div>
                                    </div>

                                    <div className="content-wrapper">
                                        <h4 className="heading heading-small light-2">WEBSITE</h4>
                                        <div className="paragraph light-1">
                                            <p>
                                                <a href="https://www.sciencenorth.ca/dynamic-earth/" target="_blank" rel="noreferrer">
                                                    www.dynamicearth.ca
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* CTA */}
                    <div className="text-content-footer">
                        <div className="container">
                            <div className="row align-items-lg-center">
                                <div className="col-md-6">
                                    <h3 className="heading heading-large light-1">
                                        Have an idea?
                                        <br />
                                        Let's explore it together.
                                    </h3>
                                </div>
                                <div className="col-md-6 d-md-inline-flex justify-content-md-end">
                                    <div className="button-wrapper">
                                        <a className="button button-1" href="/Contact">
                                            Contact Us
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="artwork artwork-2" aria-hidden="true">
                        <img src={artwork} alt="" />
                    </div>
                </div>
            </div>
        </>
    ),
};

export default Data_OntarioMineRescue;
